const HiCommonSupport = {
  /**
   * Busca el elemento activo que contiene el foco y lo elimina.
   * Esto permite en dispositivos android ocultar el teclado.
   * @returns {void}
   */
  EliminarFocoElementoActivo() {
    const elementoActivo = document.activeElement;
    elementoActivo.blur();
  },

  /**
   * Obtiene una cadena con los Id de los objetos contenidos en el array.
   * @param {any[]} arrayObjetos
   * @returns {string} La cadena con los Id de los objetos.
   */
  ObtenerCadenaIds(arrayObjetos) {
    let cadenaString = '';
    if (arrayObjetos.length === 1) {
      return arrayObjetos[0].Id;
    }

    if (arrayObjetos.length === 0) {
      return cadenaString;
    }

    for (let i = 0; i < arrayObjetos.length; i += 1) {
      cadenaString = `${cadenaString},${arrayObjetos[i].Id}`;
    }

    return cadenaString.substring(1, cadenaString.length);
  },
};

export default HiCommonSupport;
